import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-auto-closure',
  templateUrl: './edit-auto-closure.component.html',
  styleUrls: ['./edit-auto-closure.component.scss']
})
export class EditAutoClosureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
